import { IconButton } from "@mui/material";
import {
  XIcon,
  ArrowsLeftRightIcon,
  ArrowRightIcon,
} from "@phosphor-icons/react";

import { BackButton } from "@/components/BackButton/BackButton";
import { TripType } from "@/types/enums";
import type { TFlightFormValues } from "@/types/types";
import { getCityName } from "@/utils/locations";

type Props = {
  searchData: TFlightFormValues;
  onCancel: () => void;
  onBack: () => void;
};

const Header = ({ searchData, onCancel, onBack }: Props) => {
  return (
    <div className="flex items-center justify-between p-2">
      <BackButton onClick={onBack} />
      <div className="flex items-center justify-center gap-2">
        <h3 className="font-medium text-text-title">
          {getCityName(searchData.from)}
        </h3>
        {searchData.tripType === TripType.ROUND_TRIP ? (
          <ArrowsLeftRightIcon size={16} color="#003E2B" />
        ) : (
          <ArrowRightIcon
            size={16}
            color="#003E2B"
            className="rtl:-scale-x-100"
          />
        )}
        <h3 className="font-medium text-text-title">
          {getCityName(searchData.to)}
        </h3>
      </div>
      <IconButton onClick={onCancel}>
        <XIcon size={24} color="text-text-title" />
      </IconButton>
    </div>
  );
};

export default Header;
